import { useSocket } from 'contexts/SocketProvider';
import { Socket } from 'socket.io-client';

interface UseSocketConnectionConfig {
  namespace?: string;
  path?: string;
  reconnection?: boolean;
  reconnectionAttempts?: number;
  reconnectionDelay?: number;
  autoConnect?: boolean;
}

interface UseSocketConnectionReturn {
  socket: Socket | null;
  isConnected: boolean;
  error: string | null;
  connect: () => void;
  disconnect: () => void;
}

/**
 * @deprecated Use useSocket from SocketProvider instead.
 * This hook now delegates to the shared socket context to prevent multiple connections.
 */
export const useSocketConnection = (_config?: UseSocketConnectionConfig): UseSocketConnectionReturn => {
  // Delegate to the shared socket context
  return useSocket();
};
